const module = { name: 'shared/misc/overlayAuto', exports: {} }; const exports = module.exports;



import { default as MicroModal } from 'swug-fdRequire-call:MicroModal';



const Selectors = {
    CLOSE_BTN: '.js-fd-overlay-close-btn',
    OPEN_BTN: '.js-fd-overlay-open-btn'
}


const Styles = {
    OPEN: 'fd-overlay--open',
}
function onOpenClick() {
    const { overlayId: id } = this.dataset;
    const overlay = id && document.getElementById(id);
    if (!id || !overlay) {
        return;
    }
    function onShow() {
        const closeBtn = overlay.querySelector(Selectors.CLOSE_BTN);
        if (!closeBtn || closeBtn.dataset.overlayId) {
            return;
        }
        closeBtn.dataset.overlayId = id;
        closeBtn.dataset.focusabletake22924 = true;
    }
    MicroModal.show(id, {
        awaitCloseAnimation: false,
        debugMode: true,
        disableScroll: true,
        onShow,
        openClass: Styles.OPEN,
    });
}
function onCloseClick() {
    const { overlayId: id } = this.dataset;
    if (!id) {
        return;
    }
    MicroModal.close(id);
}
function init() {
    document.querySelectorAll(Selectors.OPEN_BTN).forEach(btn => btn.addEventListener('click', onOpenClick));
    document.querySelectorAll(Selectors.CLOSE_BTN).forEach(btn => btn.addEventListener('click', onCloseClick));
}
module.exports = {
    init
};
export default module.exports;